import { useState } from "react";
import NetSheetCalculator from "./NetSheetCalculator";
import BoilerplatesTab from "./BoilerplatesTab";
import CheatSheetsTab from "./CheatSheetsTab";

const categories = [
  { id: "calculators",  label: "Calculators" },
  { id: "cheatsheets",  label: "Cheat Sheets" },
  { id: "boilerplates", label: "Boilerplates" },
];

export default function ToolsTab({ projectId }) {
  const [active, setActive] = useState("calculators");

  return (
    <div style={{ backgroundColor: '#f4f5f7', minHeight: '100%' }}>

      {/* Pill Button Row */}
      <div style={{
        display: 'flex',
        gap: 10,
        padding: '20px 24px 0 24px',
        flexWrap: 'wrap',
      }}>
        {categories.map((cat) => {
          const isActive = active === cat.id;
          return (
            <button
              key={cat.id}
              onClick={() => setActive(cat.id)}
              style={{
                flex: 1,
                padding: '9px 8px',
                borderRadius: 999,
                border: isActive ? '2px solid #071D39' : '2px solid #d0d4da',
                backgroundColor: isActive ? '#071D39' : '#ffffff',
                color: isActive ? '#ffffff' : '#516469',
                fontSize: 13,
                fontWeight: isActive ? 700 : 500,
                cursor: 'pointer',
                fontFamily: 'inherit',
                transition: 'all 0.15s ease',
                boxShadow: isActive ? '0 2px 8px rgba(7,29,57,0.15)' : 'none',
                textAlign: 'center',
                whiteSpace: 'nowrap',
              }}
            >
              {cat.label}
            </button>
          );
        })}
      </div>

      {/* Content */}
      <div style={{ padding: '16px 0 0 0' }}>
        {active === "calculators"  && <NetSheetCalculator />}
        {active === "cheatsheets"  && <CheatSheetsTab projectId={projectId} />}
        {active === "boilerplates" && <BoilerplatesTab />}
      </div>

    </div>
  );
}